import { defineComponent as _defineComponent } from 'vue'
import { CodeAnalysisStatus, RepositoryKindChoices } from '~/types/types'


import { Repository } from '~/types/types'

export type RepoSlim = Pick<
  Repository,
  | 'id'
  | 'name'
  | 'displayName'
  | 'isPrivate'
  | 'codeAnalysisStatus'
  | 'hasTestCoverage'
  | 'isScaEnabled'
  | 'kind'
  | 'repositoryGroup'
> & {
  subRepos?: { totalCount?: number | null } | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RepoTable',
  props: {
    repoList: null,
    loading: { type: Boolean },
    shouldHideGroup: { type: Boolean },
    showDelete: { type: Boolean },
    isMonorepoTable: { type: Boolean }
  },
  emits: ["clickRepo", "deleteRepo"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'clickRepo', repo: string): void
  (e: 'deleteRepo', repoId: string): void
}), expose: any, slots: any, attrs: any }) {





function codeAnalysisTagState(status: CodeAnalysisStatus): string {
  switch (status) {
    case CodeAnalysisStatus.Active:
      return 'juniper'
    case CodeAnalysisStatus.Inactive:
      return 'vanilla-dark'
    case CodeAnalysisStatus.Adhoc:
      return 'honey'
    case CodeAnalysisStatus.Error:
      return 'cherry'
    default:
      return 'vanilla-dark'
  }
}

function codeAnalysisTagText(status: CodeAnalysisStatus) {
  switch (status) {
    case CodeAnalysisStatus.Active:
      return 'ACTIVE'
    case CodeAnalysisStatus.Inactive:
      return 'INACTIVE'
    case CodeAnalysisStatus.Adhoc:
      return 'COMMIT PENDING'
    case CodeAnalysisStatus.Error:
      return 'ERROR'
    default:
      return 'INACTIVE'
  }
}

function booleanTagState(status: boolean | null | undefined): string {
  switch (status) {
    case true:
      return 'juniper'
    case false:
      return 'vanilla-dark'
    default:
      return 'vanilla-dark'
  }
}

function booleanTagText(status: boolean | null | undefined) {
  switch (status) {
    case true:
      return 'ACTIVE'
    case false:
      return 'INACTIVE'
    default:
      return 'INACTIVE'
  }
}

function icon(kind: RepositoryKindChoices, isPrivate: boolean) {
  if (kind === RepositoryKindChoices.Subrepo) {
    return isPrivate ? 'folder-locked' : 'folder-globe'
  } else if (kind === RepositoryKindChoices.Repo) {
    return isPrivate ? 'z-lock' : 'globe'
  }

  return 'monorepo'
}

function getRepositoryGroupName(repo: RepoSlim) {
  return repo.repositoryGroup ? repo.repositoryGroup.name : 'Default'
}

function goToRepo(repo: string) {
  emits('clickRepo', repo)
}

return { __sfc: true,emits, codeAnalysisTagState, codeAnalysisTagText, booleanTagState, booleanTagText, icon, getRepositoryGroupName, goToRepo }
}

})